import http from "@seims/shared/src/services/HttpService";

var endpoint = `system/faqs/public-module`;
const headers = {};


const getFaq = async (targetmodule) => {
     const response = await http.get(`${endpoint}/${targetmodule}`);
     return response;
  };

export default { getFaq}